import * as React from "react";
import { ThemeProvider } from "styled-components";
import { MantineProvider } from "@mantine/core";
import useThemes from "theme/hooks/useThemes";
import ColorSchemeContext from "./ColorSchemeContext";
const GraylogThemeProvider = ({ children, initialThemeModeOverride = void 0, userIsLoggedIn }) => {
  const { scTheme, mantineTheme, colorScheme } = useThemes(initialThemeModeOverride, userIsLoggedIn);
  return /* @__PURE__ */ React.createElement(ColorSchemeContext.Provider, { value: colorScheme }, /* @__PURE__ */ React.createElement(MantineProvider, { theme: mantineTheme, forceColorScheme: colorScheme }, /* @__PURE__ */ React.createElement(ThemeProvider, { theme: scTheme }, children)));
};
export default GraylogThemeProvider;
